__turbopack_context__.v({
  "blankSpace": "Projects-module-scss-module__zl41ZW__blankSpace",
  "blink": "Projects-module-scss-module__zl41ZW__blink",
  "filterList": "Projects-module-scss-module__zl41ZW__filterList",
});
